import { render } from "./DensityEstimation.vue?vue&type=template&id=2acbd9e4"
import script from "./DensityEstimation.vue?vue&type=script&lang=js"
export * from "./DensityEstimation.vue?vue&type=script&lang=js"

import "./DensityEstimation.vue?vue&type=style&index=0&id=2acbd9e4&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__